export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    width: 85,
    slots: { default: 'opt' },
  },
  {
    title: that.$l('INDEX.goods_label_orderGoodsNo') || '产品编号',
    field: 'orderGoodsNo',
    minWidth: 150,
    align: 'center',
  },
  {
    title: that.$l('INDEX.goods_label_identifyGoodsNo') || '产品识别编号',
    field: 'identifyGoodsNo',
    minWidth: 200,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.goods_label_orderGoodsName') || '产品名称',
    field: 'orderGoodsDisplayName',
    minWidth: 200,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.goods_label_isGroup') || '是否套装',
    field: 'v_isGroup',
    minWidth: 80,
    align: 'center',
    slots: { default: 'isGroup' },
  },
  {
    title:
      that.$l('INDEX.goods_package_size_label_goodsLength') || '包装长（cm）',
    field: 'goodsLength',
    minWidth: 80,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title:
      that.$l('INDEX.goods_package_size_label_goodsWidth') || '包装宽（cm）',
    field: 'goodsWidth',
    minWidth: 80,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title:
      that.$l('INDEX.goods_package_size_label_goodsHeight') || '包装高（cm）',
    field: 'goodsHeight',
    minWidth: 80,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.goods_package_size_label_goodsWeight') || '净重(g)',
    field: 'goodsWeight',
    minWidth: 80,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'modifyByName',
    align: 'center',
    minWidth: 100,
    title: that.$l('INDEX.table_label_modified_by') || '修改人',
    showHeaderOverflow: true,
  },
  {
    field: 'modifyTime',
    align: 'center',
    minWidth: 170,
    title: that.$l('INDEX.table_label_modification_date') || '修改时间',
    showHeaderOverflow: true,
  },
]
